export default "__VITE_ASSET__DguIFamx__"